var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSclenLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1324 12.4457V0L0 11.2787L17.9774 18.5906L6.69505 11.4645L15.8901 4.2245L18.1324 12.4457Z",
    fill: "#597EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66014 17.5543V30L27.7925 18.7213L9.81517 11.4084L21.0975 18.5355L11.9024 25.7755L9.66014 17.5543Z",
    fill: "#50E3C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSclenLogo);
export default __webpack_public_path__ + "static/media/sclenLogo.e4bfd9af7dcd6307a38f789568dd4350.svg";
export { ForwardRef as ReactComponent };